import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerPlacementRequest extends BaseUpdateRequest {
    jobWorkerOfferId: string;
    startDate: string;
    fee = 0;
}